import { NestedOption } from '~/core/shared/types/utility';
import { LABEL_SEPARATOR } from '../constants/separator';
import { resolveNestedOptionBranch } from './resolveNestedOptionBranch';

export const getNestedOptionLabel = (
  options: readonly NestedOption[],
  path: string | null | undefined,
): string | null =>
  resolveNestedOptionBranch(options, path)
    ?.map((option) => option.label)
    .join(LABEL_SEPARATOR) ?? null;
